import { useToken } from "./tokenContext";
import axios from "axios";

const useApi = () => {
  const { token } = useToken();
  const apiUrl = process.env.REACT_APP_API_URL;

  // Função auxiliar para criar instâncias de API com a porta correta
  const createApiInstance = () => {
    return axios.create({
      baseURL: `${apiUrl}`,
    });
  };

  const fetchData = async (url) => {
    const api = createApiInstance();
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (
      response.data &&
      typeof response.data === "object" &&
      "data" in response.data
    ) {
      const mainData = response.data.data;
      Object.keys(response.data).forEach((key) => {
        if (key !== "data") {
          response[key] = response.data[key];
        }
      });
      response.data = mainData;
    }

    return response;
  };

  const deleteData = async (url) => {
    const api = createApiInstance();
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  };

  const updateData = async (url, data) => {
    const api = createApiInstance();
    const response = await api.patch(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

  const postData = async (url, data) => {
    const api = createApiInstance();
    const response = await api.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

  const userLogin = async (url, data) => {
    const api = createApiInstance();
    const response = await api.post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  };

  const putData = async (url, data) => {
    const api = createApiInstance();
    const response = await api.put(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

  const postCSV = async (url, data) => {
    const api = createApiInstance();
    const response = await api.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    });
    return response.data;
  };

  return {
    fetchData,
    deleteData,
    updateData,
    postData,
    putData,
    postCSV,
    userLogin,
  };
};

export default useApi;
